export const Toggle = ({
  value,
  onChange,
}: {
  value: unknown;
  onChange?: (value: boolean) => any;
}) => {
  return (
    <div
      className={`
        relative w-[45px] h-[25px] rounded-full cursor-pointer transition-all
        ${value ? `bg-[#2C3548]` : 'bg-[#B1B4BB]'}
      `}
      onClick={() => onChange?.(!value)}
    >
      <div
        className={`
          absolute left-0 top-0 h-[25px] w-[25px] p-[3px] transition-all
          
        `}
        style={{
          transform: `translateX(${value ? '20px' : '0px'})`,
        }}
      >
        <div className="rounded-full bg-white h-full" />
      </div>
    </div>
  );
};
